import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=7cf4163e&scoped=true&"
import script from "./Done.vue?vue&type=script&lang=js&"
export * from "./Done.vue?vue&type=script&lang=js&"
import style0 from "./Done.vue?vue&type=style&index=0&id=7cf4163e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf4163e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
